import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const h2 = { fontSize: 'var(--text-lg)', fontWeight: 700, marginTop: '2rem', marginBottom: '0.75rem' };
const p = { color: 'var(--ink)', lineHeight: 1.7, marginBottom: '1rem' };
const ul = { color: 'var(--ink)', lineHeight: 1.7, marginBottom: '1rem', paddingLeft: '1.25rem' };

export default function Terms() {
  return (
    <div className="page">
      <Navbar />
      <div className="container" style={{ padding: '2.5rem 1rem', maxWidth: 760 }}>
        <h1 style={{ fontSize: 'var(--text-2xl)', fontWeight: 800, marginBottom: '0.5rem' }}>Terms of Use</h1>
        <p style={{ color: 'var(--ink-muted)', marginBottom: '1.5rem' }}>Last updated: July 16, 2026</p>

        <div className="alert alert-info">
          This is placeholder legal text for demo purposes and has not been reviewed by an attorney.
          Replace it with terms prepared for your jurisdiction before launch.
        </div>

        <p style={p}>
          These Terms of Use ("Terms") govern your access to and use of ShareTime, a marketplace operated
          by Blue Signal LLC ("ShareTime," "we," "us," or "our") that connects timeshare owners with
          travelers looking to rent or buy unused weeks. By creating an account or using the site, you
          agree to these Terms.
        </p>

        <h2 style={h2}>1. Eligibility and Accounts</h2>
        <p style={p}>
          You must be at least 18 years old and able to form a binding contract to use ShareTime. You are
          responsible for maintaining the confidentiality of your login credentials and for all activity
          that occurs under your account.
        </p>

        <h2 style={h2}>2. ShareTime Is a Marketplace, Not a Party to Your Stay</h2>
        <p style={p}>
          ShareTime provides a platform for owners to list unused timeshare weeks and for buyers to rent
          or purchase them directly from owners. ShareTime is not the owner, operator, or manager of any
          resort or unit, and is not a party to the rental or resale agreement formed between an owner and
          a buyer. Owners are solely responsible for the accuracy of their listings and for honoring
          confirmed bookings; buyers are solely responsible for reviewing listing details before booking.
        </p>

        <h2 style={h2}>3. Listings, Pricing, and Fees</h2>
        <ul style={ul}>
          <li>Owners set a ceiling and floor price for each listing; the displayed price decreases automatically over time toward the floor as described on the site.</li>
          <li>Owners may be charged a listing activation fee, and ShareTime may retain a platform fee from completed bookings, as disclosed at the time of listing or purchase.</li>
          <li>For resale (for-sale) listings, offers submitted through ShareTime are forwarded to the resort's sales team or the owner; ShareTime does not charge a transaction fee on resale offers and is not a party to any resulting sale.</li>
        </ul>

        <h2 style={h2}>4. Payments</h2>
        <p style={p}>
          Payments are processed by our third-party payment processor, Stripe. By making a purchase, you
          agree to Stripe's terms of service in addition to these Terms. Funds for a confirmed booking may
          be held until the stay is completed and released to the owner afterward, as described on the site.
        </p>

        <h2 style={h2}>5. Cancellations and Refunds</h2>
        <p style={p}>
          Cancellation eligibility and refund amounts depend on how close to check-in a booking is
          cancelled, as shown in the listing's cancellation policy at the time of booking. Refunds, when
          applicable, are issued to the original payment method.
        </p>

        <h2 style={h2}>6. On-Platform Messaging and Guest Authorization</h2>
        <p style={p}>
          ShareTime provides messaging tools so buyers and owners can communicate without sharing private
          contact information. Owners are responsible for authorizing guests with the resort as required
          for check-in. Misuse of messaging — including harassment, spam, or attempts to solicit
          payment outside the platform to avoid fees — is prohibited.
        </p>

        <h2 style={h2}>7. Prohibited Conduct</h2>
        <ul style={ul}>
          <li>Listing a property or week you do not have the right to rent or sell.</li>
          <li>Providing false, misleading, or fraudulent information in a listing, booking, or message.</li>
          <li>Circumventing ShareTime's fees by completing a transaction initiated on the platform off-platform.</li>
          <li>Attempting to interfere with, disrupt, or gain unauthorized access to the site or other users' accounts.</li>
        </ul>

        <h2 style={h2}>8. Disclaimers and Limitation of Liability</h2>
        <p style={p}>
          ShareTime is provided "as is" without warranties of any kind. To the fullest extent permitted by
          law, ShareTime and Blue Signal LLC are not liable for indirect, incidental, or consequential
          damages arising from your use of the site, a booking, or a resale transaction, including
          disputes between owners and buyers or issues arising at the resort.
        </p>

        <h2 style={h2}>9. Termination</h2>
        <p style={p}>
          We may suspend or terminate your access to ShareTime if you violate these Terms or engage in
          conduct we believe is harmful to the platform or other users.
        </p>

        <h2 style={h2}>10. Changes to These Terms</h2>
        <p style={p}>
          We may update these Terms from time to time. Continued use of ShareTime after changes take
          effect constitutes acceptance of the updated Terms.
        </p>

        <h2 style={h2}>11. Governing Law</h2>
        <p style={p}>
          These Terms are governed by the laws of the State of Florida, without regard to its conflict of
          law principles.
        </p>

        <h2 style={h2}>12. Contact Us</h2>
        <p style={p}>
          Questions about these Terms can be sent to <a href="mailto:bluesignalllc@gmail.com">bluesignalllc@gmail.com</a>.
        </p>
      </div>
      <Footer />
    </div>
  );
}
